import message from "../../../src/ValidationMessage.json";

export const validatePassword = (password) => {
  const num = /.*[0-9].*/.test(password);
  let firstChar = password?.substring(0, 1);
  let checkSpecial = /[@#%&$()^~{}]+/.test(password);
  const isValid = /[a-z]/.test(password);
  if (
    firstChar !== firstChar?.toUpperCase() ||
    !isNaN(firstChar) ||
    /[*@!#%&$()^`~{}]+/.test(firstChar) !== false
  ) {
    return message.UPPERCASE;
  } else if (!isValid) {
    return message.LOWER_CASE_CHARACTER;
  } else if (!checkSpecial) {
    return message.SPECIAL_CHARACTER;
  } else if (!num) {
    return message.AT_LEAST_DIGIT;
  } else if (password.length < 6) {
    return message.USER_NAME_LENGTH;
  } else {
    return "";
  }
};

export const validateEmail = (email) => {
  const check = /\S+@\S+\.\S+/.test(email);
  if (!check) {
    return message.VALID_EMAIL_ADDRESS;
  } else {
    return "";
  }
};
export const validateTokenCode = (token) => {
  if (!token) {
    return "please enter a token";
  } else {
    return "";
  }
};

export const validateName = (condition) => {
  const letters = /^[a-zA-Z\s]+$/.test(condition);
  if (!letters) {
    return message.VALID_USERNAME;
  } else {
    return "";
  }
};

export const validateCountry = (country) => {
  if (!country) {
    return message.SELECT_COUNTRY;
  } else {
    return "";
  }
};

export const validateRoundNo = (no) => {
  if (!no) {
    return message.ENTER_ROUND_NO;
  } else if (no > 999) {
    return message.MAXMIMUM_ROUND_NO;
  } else {
    return "";
  }
};
export const validatePaymentMethod = (method) => {
  if (!method) {
    return "Please enter payment method";
  } else if (method.length > 40) {
    return "Payment method cannot be more than 40";
  } else {
    return "";
  }
};
export const validateMinimumPurchase = (purchase) => {
  if (!purchase) {
    return "Please enter minimum purchase";
  } else if (purchase > 9999999999) {
    return "Minimum purchase must be in only 12 digits";
  } else {
    return "";
  }
};
export const validateRoundPercent = (percent) => {
  const percentage = percent;
  if (percentage !== "") {
    if (percentage < 0 || percentage > 100) {
      return "Round percentage must be between 0 and 100";
    } else if (percentage % 1 !== 0) {
      return "Round percentage must be a whole number";
    }
  } else {
    return "Please enter percentage";
  }
};

export const validateVestingPeriod = (percent) => {
  const maxVal = percent > 99;
  const minimum = percent < 1;
  if (!percent) {
    return "Please enter vesting period";
  } else if (minimum) {
    return "Vesting period cannot be less than 1";
  } else if (maxVal) {
    return "Vesting period cannot be in three digit";
  } else {
    return "";
  }
};
export const validateMonthlyRealese = (realese) => {
  const percentage = realese;
  if (percentage !== "") {
    if (percentage < 0 || percentage > 100) {
      return "Round percentage must be between 0 and 100";
    } else if (percentage % 1 !== 0) {
      return "Round percentage must be a whole number";
    }
  } else {
    return "Please enter percentage";
  }
};
export const validateTokenQuantity = (quantity) => {
  if (!quantity) {
    return message.ENTER_TOKEN_QUANTITY;
  } else {
    return "";
  }
};
export const validatePrice = (price) => {
  const maximumValue = 99999999999;
  if (!price) {
    return message.ENTER_PRICE;
  } else if (price > maximumValue) {
    return message.MAXIMUM_PRICE;
  } else {
    return "";
  }
};
export const validateDatePicker = (date) => {
  if (!date) {
    return message.SELECT_DATE;
  } else {
    return "";
  }
};

export const validateConfirmPassword = (cond) => {
  if (!cond) {
    return message.SAME_PASSWORD;
  } else {
    return "";
  }
};
